import React, { useState } from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import { Link } from "react-router-dom";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import doctorsData from "../../Data/specialists/specialistsData.json";
import omcData from "../../Data/specialists/receptionOMC.json";

export default function ReceptionOMC() {
  useSEO(seoConfig.receptionOmc);

  const [hoveredDoctor, setHoveredDoctor] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const headers = [
    "Врач",
    "Кабинет",
    "Понедельник",
    "Вторник",
    "Среда",
    "Четверг",
    "Пятница",
  ];

  const doctorsMap = doctorsData.reduce((acc, doctor) => {
    acc[doctor.slug] = doctor;
    return acc;
  }, {});

  const handleMouseMove = (e) => {
    setMousePosition({
      x: e.clientX + 20,
      y: e.clientY - 20,
    });
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        График работы врачей консультативно-диагностического отделения в рамках
        территориальной программы ОМС
      </h1>

      <table className="contacts__table first_table">
        {omcData.map((section, sectionIndex) => (
          <tbody key={sectionIndex}>
            {/* <tr>
              <th className="contacts__caption" colSpan={7}>
                {section.section}
              </th>
            </tr> */}

            <tr className="contacts__line">
              {headers.map((header, i) => (
                <td key={i} className="contacts__cell second_cell">
                  {header}
                </td>
              ))}
            </tr>

            {section.doctors.map((item, index) => {
              const doctor = doctorsMap[item.slug];

              if (!doctor) return null;

              return (
                <tr className="contacts__line" key={index}>
                  <td className="contacts__cell second_cell">
                    <span
                      onMouseEnter={() => setHoveredDoctor(doctor)}
                      onMouseLeave={() => setHoveredDoctor(null)}
                      onMouseMove={handleMouseMove}
                    >
                      <Link
                        className="reception__contacts_link"
                        to={doctor.link}
                      >
                        {doctor.name}
                      </Link>
                    </span>
                    <br />
                    {doctor.degree || doctor.category || null}
                  </td>

                  <td className="contacts__cell second_cell">{item.cabinet}</td>

                  {item.work.map((day, i) => (
                    <td key={i} className="contacts__cell second_cell">
                      {day}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        ))}
      </table>

      {hoveredDoctor && (
        <div
          className="doctor-floating-preview"
          style={{
            left: mousePosition.x,
            top: mousePosition.y,
          }}
        >
          <img src={hoveredDoctor.photo} alt={hoveredDoctor.name} />
          <div className="doctor-floating-info">
            <h4>{hoveredDoctor.name}</h4>
            <p>{hoveredDoctor.position}</p>
          </div>
        </div>
      )}

      <p className="dissertation__text">
        {/* * К.М.Н. — Кандидат медицинских наук <br />* Д.М.Н. — Доктор медицинских
        наук */}
      </p>
    </section>
  );
}
